import { Icon } from '@advanza/ui'
import React from 'react'

const RequestTypeIcon = ({ request }) => {
    const { icon, name } = {
        quote: { icon: 'request_quote', name: 'Quote' },
        contact: { icon: 'perm_contact_calendar', name: 'Contact' },
        call: { icon: 'call', name: 'Call' },
        availability: { icon: 'event_available', name: 'Availability' },
        chatbot: { icon: 'smart_toy', name: 'Chatbot' },
    }[request.request_type] || { icon: 'unknown', name: 'unknown' }

    return (
        <span title={name}>
            <Icon name={icon} />
        </span>
    )
}

export default RequestTypeIcon
